import { TLink } from "../../../../../types";
import LinkWrapper from "../../../../elements/link-wrapper/link-wrapper";
import styles from "./desktop-menu-modal-content.module.less";

type TDesktopMenuModalContentProps = {
  links?: Array<TLink>;
};

const DesktopMenuModalContent = ({ links }: TDesktopMenuModalContentProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <ul className={styles.links}>
          {links?.map((link, index) => (
            <li className={styles.linkItem} key={index}>
              <LinkWrapper
                url={link?.url}
                target={link?.target}
                className={`${styles.link} body-l mb-0`}
                onPreNavigate={link?.onPreNavigate}
              >
                {link?.title}
              </LinkWrapper>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default DesktopMenuModalContent;
